import {Injectable} from '@angular/core';
import {EntityState, SignalEntityStore} from '../../state/signal-entity.store';
import {Question} from '../../models/underwriter.model';

export interface MiniQuestionState extends EntityState<Question>{

}

@Injectable({providedIn: 'root'})
export class MiniQuestionStore extends SignalEntityStore<Question, MiniQuestionState>{
    constructor() {
        super({name: 'mini-flow-questions', idKey: 'cent_aq_question_id'});
    }
}
